module.exports = __webpack_public_path__ + "static/media/company-name.b1bf627a.svg";